import { useState } from "react";
import { ArrowRight, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/api";
import { Card, Field, inputCls, btnPrimary, errMsg } from "./ui";

const EMPTY = { name: "", country: "Saudi Arabia", contact_name: "", phone: "", dentists: 5, duration_months: 12, branches: 1, requirements: "" };

export function RequestForm({ onDone, adminEmail }) {
  const [f, setF] = useState(adminEmail !== undefined ? { ...EMPTY, admin_email: "" } : EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "number" ? Number(e.target.value) : e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post(adminEmail !== undefined ? "/admin/institutions" : "/institutions/request", f);
      toast.success(adminEmail !== undefined ? "Organization created" : "Request submitted — DentiCision will prepare your quotation");
      onDone?.(data);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Card data-testid="inst-request-form">
      <form onSubmit={submit}>
        <div className="grid sm:grid-cols-2 gap-4">
          <Field label="Organization name"><input required className={inputCls} value={f.name} onChange={set("name")} data-testid="inst-req-name" /></Field>
          <Field label="Country"><input required className={inputCls} value={f.country} onChange={set("country")} data-testid="inst-req-country" /></Field>
          <Field label="Authorized contact person"><input required className={inputCls} value={f.contact_name} onChange={set("contact_name")} data-testid="inst-req-contact" /></Field>
          <Field label="Phone number"><input required className={inputCls} value={f.phone} onChange={set("phone")} data-testid="inst-req-phone" /></Field>
          {adminEmail !== undefined && <Field label="Organization admin email"><input required type="email" className={inputCls} value={f.admin_email} onChange={set("admin_email")} data-testid="inst-req-admin-email" /></Field>}
          <Field label="Number of dentists"><input required type="number" min={1} className={inputCls} value={f.dentists} onChange={set("dentists")} data-testid="inst-req-dentists" /></Field>
          <Field label="Requested duration (months)">
            <select className={inputCls} value={f.duration_months} onChange={set("duration_months")} data-testid="inst-req-duration">
              {[6, 12, 24, 36].map((m) => <option key={m} value={m}>{`${m} months`}</option>)}
            </select>
          </Field>
          <Field label="Number of branches"><input type="number" min={1} className={inputCls} value={f.branches} onChange={set("branches")} data-testid="inst-req-branches" /></Field>
        </div>
        <div className="mt-4"><Field label="Additional requirements (optional)"><textarea rows={3} className={`${inputCls} h-auto py-2`} value={f.requirements} onChange={set("requirements")} data-testid="inst-req-requirements" /></Field></div>
        {adminEmail === undefined && <p className="text-xs text-slate-500 mt-3">Your DentiCision account becomes the organization admin. Business email: the email of this account.</p>}
        <button type="submit" disabled={busy} className={`${btnPrimary} w-full mt-5 h-11`} data-testid="inst-req-submit">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <>{adminEmail !== undefined ? "Create organization" : "Submit request"} <ArrowRight className="w-4 h-4" /></>}
        </button>
      </form>
    </Card>
  );
}
